import React, { useState } from 'react';
import { DataCard } from '@/reports/index';
import {
  distanceFromProperty,
  sexOffenderOverview,
} from '@/reports/property/utils/neighborhoodSafety';
import { supportingTypes } from '@/reports/types';
import { Text, Table, Icons, styled } from '@/theme/index';

interface SexOffenderCardProps {
  sexOffender: supportingTypes.SexOffenders[number];
  index: number;
}

const FlexDiv = styled('div')`
  display: flex;
`;

const FlexDivSpaceBetween = styled('div')`
  display: flex;
  justify-content: space-between;
`;

const Image = styled('img')`
  height: 100px;
  width: 100px;
  object-fit: cover;
`;

// TODO: replace with placeholder image
const PlaceholderImage = styled('div')`
  height: 100px;
  width: 100px;
  backgound-color: gray;
`;

export const SexOffenderCard = ({
  sexOffender,
  index,
}: SexOffenderCardProps) => {
  const [expanded, setExpanded] = useState(index === 0);

  const renderSexOffenderAddresses = (
    sexOffender: supportingTypes.SexOffenders[number]
  ) => {
    return sexOffender.residences.map((residence, index) => {
      const header = [
        'Addresses',
        residence?.distance?.toFixed(2)
          ? `${residence.distance.toFixed(2)} miles away`
          : '-',
      ];
      const data = [['Home address', residence?.address?.full || '-']];
      return <Table headers={header} rows={data} key={index} />;
    });
  };

  const renderSexOffenderCharges = (
    sexOffender: supportingTypes.SexOffenders[number]
  ) => {
    return sexOffender.charges.map((charge, index) => {
      const header = ['Sex Crimes Conviction', charge?.charge || '-'];
      const data = [];
      if (sexOffender.id) {
        data.push(['Offender ID', sexOffender.id]);
      }
      data.push(['Conviction date', charge?.conviction_date?.full || '-']);
      return <Table headers={header} rows={data} key={index} />;
    });
  };

  return (
    <DataCard key={index}>
      <FlexDivSpaceBetween>
        <FlexDiv>
          {sexOffender?.picture_url ? (
            <Image src={sexOffender.picture_url} />
          ) : (
            <PlaceholderImage />
          )}
          <div>
            <Text>
              {index + 1} {sexOffender?.name?.full}
            </Text>
            <Text>{distanceFromProperty(sexOffender)} miles away</Text>
          </div>
        </FlexDiv>
        {expanded ? (
          <Icons.Remove
            color="primary"
            onClick={() => setExpanded(!expanded)}
          />
        ) : (
          <Icons.Add color="primary" onClick={() => setExpanded(!expanded)} />
        )}
      </FlexDivSpaceBetween>

      {expanded && (
        <>
          <Table rows={sexOffenderOverview(sexOffender)} />
          {renderSexOffenderAddresses(sexOffender)}
          {renderSexOffenderCharges(sexOffender)}
        </>
      )}
    </DataCard>
  );
};
